import React from "react";

const VaultQueueModel = () => {
  return (
    <section>
      <p>
        Vault Queue Model The Vault Queue Model is USCY&apos;s deterministic
        mechanism for ordering vaults and managing redemption sequencing. It is
        central to maintaining economic fairness and yield separation. Core
        Rules Every mint creates a new vault. New vaults enter at the front of
        the queue. The front vault is the next to be redeemed. Rear vaults have
        the longest remaining reward duration. Queue Dynamics Expansion: vaults
        drift backward naturally Contraction: vaults move forward more quickly
        Temporary protection: new vaults cannot be redeemed until the next
        reward cycle YPP override: institutions can improve queue position using
        YPPs Role in Yield Separation Because yield accrues at the vault level —
        not at token balances — the queue ensures: Predictable vault lifecycle
        Transparent reward duration No preferential issuer treatment
        GENIUS-compliant separation between token and yield Related Concepts
        USCY YPP Redemption Process
      </p>
    </section>
  );
};

export default VaultQueueModel;
